import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { PgaRequirementsModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class HtsRepository {
  constructor(private apiService: ApiService) {}

  public checkHTSCode(number: string): Observable<PgaRequirementsModel> {
    return this.apiService.get(`${environment.url.prefixCustoms}hts/${number}/requirements`, null, { isUsed: true });
  }
}
